(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('notification-preferences', {
            parent: 'account',
            url: '/notification-preferences?typeKey',
            params: {
                typeKey: {
                    value: null,
                    squash: true
                }
            },
            data: {
                authorities: [/^ROLE_.*/gi],
                pageTitle: 'global.menu.account.notificationPreferences'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/notification-preferences/notification-preferences.html',
                    controller: 'NotificationPreferencesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notification-preferences');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

